/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useContext, useEffect } from 'react';
import { Grid } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
// import APITable from 'components/BiteAPI/Table';
import { Modal } from '@mui/material';
import NewAPIModal from 'components/BiteAPI/NewAPIModal';
import APIModal from 'components/BiteAPI/APIModal';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { GlobalContext } from 'providers/GlobalProvider';
import BiteAPIapi from 'api/BITEapiAPI';
import MeterTable from 'components/BiteAPI/MeterTable';
import PaymentModal from 'components/BiteAPI/PaymentModal';
import DeleteModal from 'components/BiteAPI/deleteAPIModal';
// import PaymentsAPI from 'api/PaymentsAPI';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PricingTable from 'components/BiteAPI/PricingTable';
import MeterTablePlaceholder from 'components/BiteAPI/MeterTablePlaceholder';

interface TeamKeys {
  name: string;
  id: string;
}
const BiteAPI: React.FC = () => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();

  const [ matchedTeamWithStripe, setMatchedTeamWithStripe ] = useState<any>({});
  const [ newAPIModalOpen, setNewAPIModalOpen ] = useState(false);
  const [ paymentModalOpen, setPaymentModalOpen ] = useState(false);
  const [ deleteModalOpen, setDeleteModalOpen ] = useState(false);
  const [ deleteId, setDeleteId ] = useState('');
  const [ selectedOpt, setSelectedOpt ] = useState('');
  const [ infoModalOpen, setInfoModalOpen ] = useState(false);
  const [ isKeyBlur, setIsKeyBlur ] = useState(true);

  const [ createSuccess, setCreateSuccess ] = React.useState(false);
  const [ failNotify, setFailNotify ] = React.useState(false);

  const [ id, setId ] = useState('');
  const [ name, setName ] = useState('');
  const [ path, setPath ] = useState('');
  const [ token, setToken ] = useState('');
  const [ endpoint, setEndpoint ] = useState('');
  const [ method, setMethod ] = useState('');

  const [ params, setParams ] = useState([ { key: '', value: '' } ]);

  const [ calls, setCalls ] = useState<any[]>([]);
  const [ connections, setConnections ] = useState<any[]>([]);

  const [ trigger, setTrigger ] = useState(false);

  // const triggerMeter = async() => {
  //   const res = await PaymentsAPI.updateMeter({ type: 'entity_api_requests' }, 'cus_QI9861q3yuxMKC');
  //   if (res?.success) {
  //     return res?.result;
  //   }
  // };

  const [ teamsAPIKEYS, setTeamsAPIKEYS ] = useState<TeamKeys[]>([]);

  useEffect(() => {
    if (cur_user.basics?.attributes?.api_keys) {
      try {
        const parsedObject = JSON.parse(cur_user.basics?.attributes?.api_keys);
        const arrayData: TeamKeys[] = Object.entries(parsedObject).map(([ name, id ]) => ({
          name: name,
          id: id as string,
        }));
        setTeamsAPIKEYS(arrayData);
      } catch (error) {
        console.error('Invalid JSON:', error);
      }
    }
  }, [ cur_user.basics?.attributes?.api_keys ]);

  const handleNotify = (reason: string) => {
    if (reason === 'success') {
      setCreateSuccess(true);
    } else {
      setFailNotify(true);
    }
  };

  const handleCloseNotify = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setCreateSuccess(false);
    setFailNotify(false);
  };

  const handleAPIModalOpen = () => {
    setNewAPIModalOpen(true);
  };
  const handleAPIModalClose = () => {
    setNewAPIModalOpen(false);
  };

  const handlePayModalOpen = () => {
    setPaymentModalOpen(true);
  };
  const handlePayModalClose = () => {
    setPaymentModalOpen(false);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModalOpen(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
    setDeleteId('');
  };

  const handleClose = () => {
    setInfoModalOpen(false);
    setSelectedOpt('');
    setId('');
  };

  const handleSelect = (opt: string) => {
    setNewAPIModalOpen(false);
    setSelectedOpt(opt);
    setInfoModalOpen(true);
  };

  const handleEdit = (api: any) => {
    setName(api.name);
    setId(api._id);
    setPath(api.path);
    setToken(api.toke);
    setEndpoint(api.endpoint);
    setMethod(api.methodType);
    setParams(api.params);
    setSelectedOpt(api.type);
    setInfoModalOpen(true);
  };


  const getAPIs = async() => {
    const mongoReq = {
      query: {
        groupId: cur_user.selected_team?.id,
      },
    };
    const res = await BiteAPIapi.searchAPIs(mongoReq);

    const callArr: any[] = [];
    const conArr: any[] = [];
    res?.result.forEach((api: any) => {
      if (api.type === 'retrieve') {
        callArr.push(api);
      } else {
        conArr.push(api);
      }
    });
    setCalls(callArr);
    setConnections(conArr);
  };

  const deleteApi = async() => {
    const res = await BiteAPIapi.deleteAPI(deleteId);
    if (res?.success) {
      setTrigger(!trigger);
    }
    handleDeleteModalClose();
  };

  useEffect(() => {
    getAPIs();
  }, [ trigger ]);

  useEffect(() => {
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus);
        }
      });
    }
  }, []);

  const ProfileLink = () => (

    history.push({
      pathname: '/profile',
      state: {
        linkTab: 'Plans',
      },
    })
  );

  const getTeamAPIKey = (teamName: string) => {
    const team = teamsAPIKEYS.find((team) => team.name === teamName?.toUpperCase());
    return team ? `${team.id}` : '';
  };
  return (
    <section className='home-content-body Home-HeaderDown' style={{ minHeight: 0 }} >
      <Grid container>
        <Grid item xs={12}>
          <div className='module-header'>
            <div className='module-header-breadcrumbs'>
              <Link to='/'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                  <path d='M11.6667 16.6667C11.6667 17.5871 10.9205 18.3333 10 18.3333C9.07953 18.3333 8.33333 17.5871 8.33333 16.6667M11.6667 16.6667C11.6667 15.7462 10.9205 15 10 15M11.6667 16.6667H17.5M8.33333 16.6667C8.33333 15.7462 9.07953 15 10 15M8.33333 16.6667H2.5M10 15V11.6667M17.5 4.16666C17.5 5.54737 14.1421 6.66666 10 6.66666C5.85786 6.66666 2.5 5.54737 2.5 4.16666M17.5 4.16666C17.5 2.78594 14.1421 1.66666 10 1.66666C5.85786 1.66666 2.5 2.78594 2.5 4.16666M17.5 4.16666V9.16666C17.5 10.55 14.1667 11.6667 10 11.6667M2.5 4.16666V9.16666C2.5 10.55 5.83333 11.6667 10 11.6667' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </Link>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M6 12L10 8L6 4' stroke='#D0D5DD' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <div className='bc-title'>
                BITE API
              </div>
            </div>
            <div className='homepage-header-title-conts'>
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className='api-container' style={{ gap: '10px' }}>
            <div className='api-container-left' style={{ flex: '1.2' }}>
              <h1>BITE API Overview</h1>
              <p>BITE API lets you securely and accurately screen your People, Companies, Products, and HTS Codes against BITE&apos;s comprehensive data. You can also receive optional AI Evaluation of the results from your screens and utilize the BITE Lens breakdown of data to narrow down results to only what applies to you.</p>
            </div>
            <div className='api-container-right'>
              <div className='dev-docs-banner-containers'>
                <div className='dev-docs-info'>
                  <h1>Developer Documentation</h1>
                  <h2>To view the full instructions for use of BITE API, request and response formats, and examples please view our developer documentation. Docs are build on Swagger UI.</h2>
                  <a href={`${process.env.REACT_APP_PUBLIC_API_URL}/api-docs`} target='_blank' rel='noopener noreferrer'>
                    <Button
                      sx={{ color: '#EFF1F6', background: '#4895EF', display: 'flex', gap: '4px', textTransform: 'none', padding: '10px 14px', borderRadius: '8px' }}
                    >Open Docs<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                        <path d='M5 15L15 5M15 5H8.33333M15 5V11.6667' stroke='#EFF1F6' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className='api-container-info'>
            <h1>API Features</h1>
            <div className='results-card-frames'>
              <div className='results-card-frame-comps'>
                <div className='results-card-frame-head' style={{ color:'var(--Primary-400, #4895EF)', gap: '5px', fontSize: '16px' }}>
                  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <path d='M15.75 9L6.75 9M15.75 4.5L6.75 4.5M15.75 13.5L6.75 13.5M3.75 9C3.75 9.41421 3.41421 9.75 3 9.75C2.58579 9.75 2.25 9.41421 2.25 9C2.25 8.58579 2.58579 8.25 3 8.25C3.41421 8.25 3.75 8.58579 3.75 9ZM3.75 4.5C3.75 4.91421 3.41421 5.25 3 5.25C2.58579 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75C3.41421 3.75 3.75 4.08579 3.75 4.5ZM3.75 13.5C3.75 13.9142 3.41421 14.25 3 14.25C2.58579 14.25 2.25 13.9142 2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75C3.41421 12.75 3.75 13.0858 3.75 13.5Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
              Comprehensive Screening
                </div>
                <div className='results-card-frame-bodys'>
                Screen against multiple data sources including sanctions, PEPs, denied parties, and more in a single API call.
                </div>
              </div>
              <div className='results-card-frame-comps'>
                <div className='results-card-frame-head' style={{ color:'var(--Primary-400, #4895EF)', gap: '5px', fontSize: '16px' }}>
                  <svg fill='#4895EF' width='18' height='18' viewBox='0 0 512 512' id='icons' xmlns='http://www.w3.org/2000/svg'><path d='M208,512a24.84,24.84,0,0,1-23.34-16l-39.84-103.6a16.06,16.06,0,0,0-9.19-9.19L32,343.34a25,25,0,0,1,0-46.68l103.6-39.84a16.06,16.06,0,0,0,9.19-9.19L184.66,144a25,25,0,0,1,46.68,0l39.84,103.6a16.06,16.06,0,0,0,9.19,9.19l103,39.63A25.49,25.49,0,0,1,400,320.52a24.82,24.82,0,0,1-16,22.82l-103.6,39.84a16.06,16.06,0,0,0-9.19,9.19L231.34,496A24.84,24.84,0,0,1,208,512Zm66.85-254.84h0Z'/><path d='M88,176a14.67,14.67,0,0,1-13.69-9.4L57.45,122.76a7.28,7.28,0,0,0-4.21-4.21L9.4,101.69a14.67,14.67,0,0,1,0-27.38L53.24,57.45a7.31,7.31,0,0,0,4.21-4.21L74.16,9.79A15,15,0,0,1,86.23.11,14.67,14.67,0,0,1,101.69,9.4l16.86,43.84a7.31,7.31,0,0,0,4.21,4.21L166.6,74.31a14.67,14.67,0,0,1,0,27.38l-43.84,16.86a7.28,7.28,0,0,0-4.21,4.21L101.69,166.6A14.67,14.67,0,0,1,88,176Z'/><path d='M400,256a16,16,0,0,1-14.93-10.26l-22.84-59.37a8,8,0,0,0-4.6-4.6l-59.37-22.84a16,16,0,0,1,0-29.86l59.37-22.84a8,8,0,0,0,4.6-4.6L384.9,42.68a16.45,16.45,0,0,1,13.17-10.57,16,16,0,0,1,16.86,10.15l22.84,59.37a8,8,0,0,0,4.6,4.6l59.37,22.84a16,16,0,0,1,0,29.86l-59.37,22.84a8,8,0,0,0-4.6,4.6l-22.84,59.37A16,16,0,0,1,400,256Z'/></svg>
              AI Powered Analysis
                </div>
                <div className='results-card-frame-bodys'>
                Leverage our AI to evaluate screening results and provide risk assessments with detailed explanations.
                </div>
              </div>
              <div className='results-card-frame-comps'>
                <div className='results-card-frame-head' style={{ color:'var(--Primary-400, #4895EF)', gap: '5px', fontSize: '16px' }}>
                  <svg width='28' height='28' viewBox='0 -0.5 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path fillRule='evenodd' clipRule='evenodd' d='M11.132 9.71395C10.139 11.2496 10.3328 13.2665 11.6 14.585C12.8468 15.885 14.8527 16.0883 16.335 15.065C16.6466 14.8505 16.9244 14.5906 17.159 14.294C17.3897 14.0023 17.5773 13.679 17.716 13.334C18.0006 12.6253 18.0742 11.8495 17.928 11.1C17.7841 10.3573 17.4268 9.67277 16.9 9.12995C16.3811 8.59347 15.7128 8.22552 14.982 8.07395C14.2541 7.92522 13.4982 8.00197 12.815 8.29395C12.1254 8.58951 11.5394 9.08388 11.132 9.71395Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                    <path d='M17.5986 13.6868C17.2639 13.4428 16.7947 13.5165 16.5508 13.8513C16.3069 14.1861 16.3806 14.6552 16.7154 14.8991L17.5986 13.6868ZM19.0584 16.6061C19.3931 16.85 19.8623 16.7764 20.1062 16.4416C20.3501 16.1068 20.2764 15.6377 19.9416 15.3938L19.0584 16.6061ZM7.5 12.7499C7.91421 12.7499 8.25 12.4142 8.25 11.9999C8.25 11.5857 7.91421 11.2499 7.5 11.2499V12.7499ZM5.5 11.2499C5.08579 11.2499 4.75 11.5857 4.75 11.9999C4.75 12.4142 5.08579 12.7499 5.5 12.7499V11.2499ZM7.5 15.7499C7.91421 15.7499 8.25 15.4142 8.25 14.9999C8.25 14.5857 7.91421 14.2499 7.5 14.2499V15.7499ZM5.5 14.2499C5.08579 14.2499 4.75 14.5857 4.75 14.9999C4.75 15.4142 5.08579 15.7499 5.5 15.7499V14.2499ZM8.5 9.74994C8.91421 9.74994 9.25 9.41415 9.25 8.99994C9.25 8.58573 8.91421 8.24994 8.5 8.24994V9.74994ZM5.5 8.24994C5.08579 8.24994 4.75 8.58573 4.75 8.99994C4.75 9.41415 5.08579 9.74994 5.5 9.74994V8.24994ZM16.7154 14.8991L19.0584 16.6061L19.9416 15.3938L17.5986 13.6868L16.7154 14.8991ZM7.5 11.2499H5.5V12.7499H7.5V11.2499ZM7.5 14.2499H5.5V15.7499H7.5V14.2499ZM8.5 8.24994H5.5V9.74994H8.5V8.24994Z' fill='#4895EF'/>
                  </svg>
              BITE Lens
                </div>
                <div className='results-card-frame-bodys'>
                Filter and narrow down results to only what&apos;s relevant to your specific compliance requirements.
                </div>
              </div>
              <div className='results-card-frame-comps'>
                <div className='results-card-frame-head' style={{ color:'var(--Primary-400, #4895EF)', gap: '5px', fontSize: '16px' }}>
                  <svg width='18' height='18' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M12 14.5V16.5M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
              Secure and Compliant
                </div>
                <div className='results-card-frame-bodys'>
                All API calls are encrypted and processed in compliance with global data protection regulations.
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className='api-container-info'>
            <h1>Pricing Breakdown</h1>
            <div className='results-card-frame-bodys' style={{marginBottom: '4px'}}>
              Retroactive by Tier — Highest Tier Rate Applies to All Calls
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
              <div className='api-container-left'>
                <PricingTable/>
              </div>
              <div className='api-container-right'>
                <div className='results-card-frames'>
                  <div className='results-card-frame-comps'>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                      <div className='results-card-frame-bodys'>
                        <svg fill='#4895EF' width='18' height='18' viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'><path d='M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z'/></svg>
                      </div>
                      <div className='results-card-frame-bodys'>
                        Unlimited API Access can also be purchased for BITE API. See the BITE API Bundle in the Plans tab of the Account page for details
                      </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                      <div className='results-card-frame-bodys'>
                        <svg fill='#4895EF' width='18' height='18' viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'><path d='M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z'/></svg>
                      </div>
                      <div className='results-card-frame-bodys'>
                      To gain access to BITE API ensure your team has an Enterprise License and subscribe to the plan(s) that you want at the bottom of the plans page. All API cost are in addition to the cost of the Enterprise License
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', paddingLeft: '15px' }}>
                      <div className='results-card-frame-bodys'>
                      </div>
                      { cur_user.selected_team?.attributes?.team_admin?.includes(cur_user.basics?.email) ? (
                        <div className='results-card-frame-bodys'>
                          <Link to={{
                            pathname: '/profile',
                            state: {
                              linkTab: 'Plans'
                            }
                          }}
                          >
                            <Button
                              sx={{ color: '#EFF1F6', background: '#4895EF', display: 'flex', gap: '4px', textTransform: 'none', padding: '10px 14px', borderRadius: '8px' }}
                            >
                        Subscribe Now
                            </Button>
                          </Link>
                        </div>
                      ) : (
                        <div className='results-card-frame-bodys' style={{ flexWrap: 'wrap', gap: '10px' }}>
                          <Button
                            sx={{
                              'color': '#bdbec1',
                              'background': 'rgb(74, 76, 81)',
                              'display': 'flex',
                              'gap': '4px',
                              'textTransform': 'none',
                              'padding': '10px 14px',
                              'borderRadius': '8px',
                              '&:hover': {
                                background: 'rgb(74, 76, 81)',
                                opacity: 1,
                              },
                            }}
                          >
                            Subscribe Now
                          </Button>
                          <div className='results-card-frame-bodys' style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', display:'block', fontSize: '10px' }}>
                          Only team admins have access to the plans tab of the account page. Contact your team admin if you wish to purchase API access
                          </div>
                        </div>
                      )}

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className='api-container-info'>
            <div className='api-container-infos' style={{ alignItems: 'center' }}>
              <h1>Already Subscribed?</h1>
            </div>
            <div className='api-container-right'>
              <div className='results-card-frames'>
                <div className='results-card-frame-comps' style={{ width: '100%' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <div className='results-card-frame-bodys' style={{ width: '14%' }} >
                      {
                        cur_user.selected_team?.attributes?.team_admin?.includes(cur_user.basics?.email) ? (
                          <a onClick={ () => setIsKeyBlur(!isKeyBlur)}>
                            <Button
                              sx={{ color: '#EFF1F6', background: '#4895EF', display: 'flex', gap: '4px', textTransform: 'none', padding: '10px 14px', borderRadius: '8px' }}
                            >
                        View API Keys
                            </Button>
                          </a>
                        ) : (
                          <a>
                            <Button
                              sx={{
                                'color': '#bdbec1',
                                'background': 'rgb(74, 76, 81)',
                                'display': 'flex',
                                'gap': '4px',
                                'textTransform': 'none',
                                'padding': '10px 14px',
                                'borderRadius': '8px',
                                '&:hover': {
                                  background: 'rgb(74, 76, 81)',
                                  opacity: 1,
                                },
                              }}
                            >
                        View API Keys
                            </Button>
                          </a>

                        )
                      }

                    </div>
                    <div className='results-card-frame-bodys' style={{ width: '100%' }}>
                      <div className={isKeyBlur ? 'dev-docs-banner-containers-keys-blur' : 'dev-docs-banner-containers-keys'}>
                        <div className='dev-docs-info' style={{ gap: '10px' }}>
                          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                            <div className='results-card-frame-bodys'>
                             API Key:
                            </div>
                            <div className='results-card-frame-bodys'>
                              { cur_user.selected_team?.attributes?.team_admin?.includes(cur_user.basics?.email) ? getTeamAPIKey(cur_user.selected_team.name || '') : '' }
                            </div>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                            <div className='results-card-frame-bodys'>
                             Secret Key:
                            </div>
                            <div className='results-card-frame-bodys'>
                              {cur_user.selected_team?.attributes?.team_admin?.includes(cur_user.basics?.email) && getTeamAPIKey(cur_user.selected_team.name || '') ? cur_user.basics?.id : ''}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
        {/* <button onClick={() => triggerMeter()}>TRIGGER API</button> */}
        <Grid item xs={12}>
          { Object.keys(matchedTeamWithStripe).length > 0 ? (
            <div className='api-table-container'>
              <MeterTable stripeCus={matchedTeamWithStripe} handleTabChange={ProfileLink}/>
              <div className='results-card-frame-bodys' style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', display:'block', fontSize: '14px' }}>
              To request API playground access email info@bitedata.io
              </div>
            </div>
          ) : (
            <div className='api-table-container'>
              <MeterTablePlaceholder />
              <div className='results-card-frame-bodys' style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', display:'block', fontSize: '14px' }}>
              To request API playground access email info@bitedata.io
              </div>
            </div>
          )
          }
        </Grid>
      </Grid>
      <Modal
        open={newAPIModalOpen}
        onClose={handleAPIModalClose}
      >
        <NewAPIModal
          handleAPIModalClose={handleAPIModalClose}
          handleSelect={handleSelect}
        />
      </Modal>
      <Modal
        open={paymentModalOpen}
        onClose={handlePayModalClose}
      >
        <PaymentModal
          handlePayModalClose={handlePayModalClose}
        />
      </Modal>
      <Modal
        open={deleteModalOpen}
        onClose={handleDeleteModalClose}
      >
        <DeleteModal
          handleDeleteModalClose={handleDeleteModalClose}
          handleDelete={deleteApi}
        />
      </Modal>
      <Modal
        open={infoModalOpen}
        onClose={handleClose}
      >
        <APIModal
          type={selectedOpt}
          handleClose={handleClose}
          handleNotify={handleNotify}
          name={name}
          setName={setName}
          path={path}
          setPath={setPath}
          endpoint={endpoint}
          setEndpoint={setEndpoint}
          method={method}
          setMethod={setMethod}
          params={params}
          setParams={setParams}
          token={token}
          setToken={setToken}
          id={id}
          cur_user={cur_user}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      </Modal>
      <Snackbar open={createSuccess} autoHideDuration={5000} onClose={handleCloseNotify}>
        <Alert
          onClose={handleCloseNotify}
          severity='success'
          variant='filled'
          sx={{ width: '100%' }}
        >
      API connection info has been saved!
        </Alert>
      </Snackbar>
      <Snackbar open={failNotify} autoHideDuration={5000} onClose={handleCloseNotify}>
        <Alert
          onClose={handleCloseNotify}
          severity='error'
          variant='filled'
          sx={{ width: '100%' }}
        >
          Please make sure all required fields are filled out for this API connection.
        </Alert>
      </Snackbar>
    </section>
  );
};

export default BiteAPI;


